import type { ApiProviderMigrationInventoryItem } from "@/lib/api";

export interface EvidencePacketInput {
  generatedAt: string;
  snapshotId: string;
  freshUntil: string | null;
  truncated: boolean;
  vaultAccounts: ApiProviderMigrationInventoryItem[];
  assetWallets: ApiProviderMigrationInventoryItem[];
  vaultAddresses: ApiProviderMigrationInventoryItem[];
}

export interface EvidencePacket {
  schema: "alloy.provider_migration_evidence.v1";
  label: "read-only-no-funds-moved";
  evidenceGrade: "testnet-sandbox-discovery";
  generatedAt: string;
  snapshotId: string;
  freshUntil: string | null;
  complete: boolean;
  counts: { vaultAccounts: number; assetWallets: number; vaultAddresses: number; total: number };
  items: ApiProviderMigrationInventoryItem[];
}

/** Pure and deterministic given its input. Identifiers only; carries no credential or provider attribute. */
export function buildEvidencePacket(input: EvidencePacketInput): EvidencePacket {
  const items = [...input.vaultAccounts, ...input.assetWallets, ...input.vaultAddresses].map((i) => ({
    resourceType: i.resourceType,
    providerResourceId: i.providerResourceId,
  }));
  return {
    schema: "alloy.provider_migration_evidence.v1",
    label: "read-only-no-funds-moved",
    evidenceGrade: "testnet-sandbox-discovery",
    generatedAt: input.generatedAt,
    snapshotId: input.snapshotId,
    freshUntil: input.freshUntil,
    complete: !input.truncated,
    counts: {
      vaultAccounts: input.vaultAccounts.length,
      assetWallets: input.assetWallets.length,
      vaultAddresses: input.vaultAddresses.length,
      total: items.length,
    },
    items,
  };
}
